import React from 'react';
import { motion } from 'framer-motion';
import { FiTarget, FiFilter, FiCheckCircle, FiPhoneForwarded } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const steps = [
  {
    icon: FiTarget,
    title: 'Targeted Acquisition',
    desc: 'Users engage with our highly-optimized digital ad campaigns designed for specific verticals.'
  },
  {
    icon: FiFilter,
    title: 'Pre-Screening',
    desc: 'Callers pass through automated or live triage to confirm interest and basic qualifications.'
  },
  {
    icon: FiCheckCircle,
    title: 'Quality Verification',
    desc: 'Intent is verified to ensure they meet your specific buyer persona requirements.'
  },
  {
    icon: FiPhoneForwarded,
    title: 'Direct Handoff',
    desc: 'The qualified lead is seamlessly transferred or routed directly to your sales floor.'
  }
];

const Process = () => {
  return (
    <section className="py-24 bg-slate-950 px-6 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <div className="text-left md:text-center mb-16">
          <h2 className="text-indigo-500 font-bold tracking-widest uppercase text-xs mb-3">How It Works</h2>
          <h3 className="text-3xl md:text-5xl font-black text-white tracking-tighter">LEAD QUALIFICATION PROCESS</h3>
        </div>

        <div className="grid md:grid-cols-4 gap-8 relative">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-indigo-500/0 via-indigo-500/20 to-indigo-500/0 -translate-y-1/2 z-0"></div>

          {steps.map((step, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15 }}
              className="relative z-10"
            >
              <div className="bg-slate-900 border border-white/10 rounded-2xl p-8 h-full hover:border-indigo-500/50 transition-colors group">
                <div className="w-14 h-14 bg-indigo-950 border border-indigo-500/30 rounded-xl flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(99,102,241,0.2)] group-hover:bg-indigo-600 transition-colors">
                  <SafeIcon icon={step.icon} className="text-2xl text-indigo-400 group-hover:text-white transition-colors" />
                </div>
                <div className="text-indigo-500/50 font-black text-4xl absolute top-6 right-6 opacity-20">
                  0{index + 1}
                </div>
                <h4 className="text-xl font-bold text-white mb-3">{step.title}</h4>
                <p className="text-slate-400 text-sm leading-relaxed">
                  {step.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;